import { FormErrors } from 'redux-form';
import { ContestParticipationMode } from '@Models';
import { ContestVersioning } from '@Models';

const validate = (values: ContestParams): FormErrors<ContestParams> => {
  const errors: FormErrors<ContestParams> = {};

  if (!values.name) {
    errors.name = 'contest.form.name.error';
  }

  if (!values.startDate) {
    errors.startDate = 'contest.form.startDate.error';
  }

  if (!values.endDate) {
    errors.endDate = 'contest.form.endDate.error';
  }

  if (values.startDate && values.endDate && values.startDate > values.endDate) {
    errors.endDate = 'contest.form.interval.error';
  }

  if (!values.versionId) {
    errors.versionId = 'contest.form.versionid.error';
  }

  if (
    values.participation != ContestParticipationMode.TEAM &&
    values.participation != ContestParticipationMode.INDIVIDUAL
  ) {
    errors.participation = 'contest.form.participation.error';
  }

  if (
    !values.teamMax &&
    values.participation == ContestParticipationMode.TEAM
  ) {
    errors.teamMax = 'contest.form.teamMax.error';
  }

  if (!values.userMax) {
    errors.userMax = 'contest.form.userMax.error';
  }

  if (!values.armyListMax) {
    errors.armyListMax = 'contest.form.armyListMax.error';
  }

  return errors;
};
export default validate;

export interface ContestParams extends ContestVersioning {
  startDate: Date;
  endDate: Date | null;
  versionId: number;
  participation: ContestParticipationMode;
  userMax: number;
  teamMax: number;
  armyListMax: number;
  showAllArmies: boolean;
}
